import { aboutFacts, aboutPoints } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-6">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-700 bg-primary-100 px-3 py-1.5 rounded-full">
              <i className="ri-plant-line"></i>
              关于本站
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
              一份帮你找到可靠入口的整理说明
            </h2>
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">
              香蕉社区相关的「官网」「网址」「首页」「最新地址」这些说法，常常交织在一起，
              让人不知道该从哪一条开始看。本站把它们拆开讲清楚：既说明每种入口指的是什么，
              也说明地址为什么会变、变了之后该怎么找。读完这一页，你就能用更有条理的方式去判断和访问。
            </p>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {aboutFacts.map((fact) => (
                <div key={fact.label} className="rounded-lg bg-background-100 border border-background-200/70 p-4">
                  <p className="font-heading text-lg md:text-xl text-primary-700">{fact.value}</p>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600">{fact.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="rounded-lg overflow-hidden bg-background-100 border border-background-200/70">
              <div className="w-full h-[240px] md:h-[320px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20flat%20lay%20of%20a%20bright%20community%20workspace%20scene%20with%20notebooks%2C%20warm%20amber%20accents%20and%20soft%20natural%20light%2C%20clean%20simple%20background%2C%20editorial%20photography%20style%2C%20shallow%20depth%20of%20field%2C%20welcoming%20atmosphere%2C%20high%20detail%2C%20harmonious%20color%20palette%2C%20no%20text&width=1200&height=800&seq=banana-about-desk-01&orientation=landscape"
                  alt="温暖整洁的桌面场景，象征社区信息整理"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6">
                <p className="text-sm leading-relaxed text-foreground-600">
                  页面结构按「先了解、再访问、后注意」的节奏排布，方便按顺序阅读，也方便直接跳到关心的部分。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 gap-5">
          {aboutPoints.map((point) => (
            <div
              key={point.title}
              className="rounded-lg bg-background-100 border border-background-200/70 p-6 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-start gap-4">
                <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${point.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-lg text-foreground-950">{point.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">{point.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}